import { auditReports } from '@mi-front/api-clients';
import { useAodFactory } from '../screens/aod-rules-add/custom/AodFactory';

export function AodRunActions({ run }: { run: auditReports.AodRun }) {
  const {
    views: { RunActions },
  } = useAodFactory(run.rule.reportType);

  if (!RunActions) {
    return null;
  }

  return <RunActions run={run} />;
}
